import React from "react";
import './PipelineDetails.scss';
import {stringISOtoUS} from "../../date-converter";
import {calculateTotalColumn} from "../../utils";
import dollars from "../../dollar-format";
import {Link} from "react-router";

export const proposal = 'Proposal';
export const active = 'Active';
export const negotiation = 'In Negotiation';
export const underContract = 'Under Contract';
export const closed = 'Closed';
export const closedYTD = 'Closed YTD';
export const closedHistorical = 'Closed Historical';
export const listing = 'Listing';

export default class PipelineDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    static getColumns(status, isAgentPipeline) {
        const cols = [];
        switch (status) {
            case proposal:
                cols.push({
                    label: 'Date Created',
                    key: 'DATE_CREATED',
                    style: 'center',
                });
                break;
            case active: {
                cols.push({
                    label: 'Date Listed',
                    key: 'LISTED_DATE',
                    style: 'center',
                });
                if (isAgentPipeline)
                    cols.push({
                        label: 'Expiration Date',
                        key: 'EXPIRATION_DATE',
                        style: 'center',
                    });
                break;
            }
            case negotiation:
            case underContract:
                cols.push({
                    label: 'Status',
                    key: 'STATUS',
                    style: 'center',
                });
                break;
            case closed:
            case closedYTD:
            case closedHistorical:
                cols.push({
                    label: 'Close of Escrow',
                    key: 'CLOSE_OF_ESCROW',
                    style: 'center',
                });
                break;
            case listing:
                cols.push({
                    label: 'Status',
                    key: 'STATUS',
                    style: 'center',
                }, {
                    label: 'Date',
                    key: 'LISTED_DATE',
                    style: 'center',
                });
                break;
        }
        cols.push({
            label: 'Property Name',
            key: 'NAME',
        });
        if ([active, listing, proposal].includes(status)) {
            cols.push({
                label: 'Address',
                key: 'ADDRESS',
            });
        }
        cols.push({
            label: 'City',
            key: 'CITY',
        }, {
            label: 'State',
            key: 'STATE',
            style: 'center',
        });
        let priceLabel = '';
        switch (status) {
            case proposal:
            case active:
                priceLabel = 'List Price';
                break;
            case listing:
            case negotiation:
            case underContract:
                priceLabel = 'Price';
                break;
            case closed:
            case closedYTD:
            case closedHistorical:
                priceLabel = 'Price at Close';
                break;
        }
        cols.push({
            label: priceLabel,
            key: 'PRICE',
            style: 'center',
        });
        if ([negotiation, underContract, closed, closedYTD, closedHistorical].includes(status)) {
            cols.push({
                label: '% of Deal',
                key: 'PERCENTAGE',
                style: 'center',
            }, {
                label: 'Fee Percentage',
                key: 'SELLER_FEE_PERCENTAGE',
                style: 'center',
            }, {
                label: 'Gross Fee',
                key: 'GROSS_FEE',
                style: 'center',
            }, {
                label: 'Additional Agent',
                key: 'ADDITIONAL_AGENTS',
            });
        }
        if (![proposal].includes(status)) {
            cols.push({
                label: 'Downloads',
                key: 'DOWNLOADS',
                style: 'center',
            });
        }
        return cols;
    }

    static formatAdditionalAgents(property) {
        let additionalAgents = '';
        for (let i = 1; i <= 6; i++) {
            if ((property[`ADDITIONAL_AGENT_${i}_FIRST_NAME`] || property[`ADDITIONAL_AGENT_${i}_LAST_NAME`]) &&
                (!additionalAgents.includes(property[`ADDITIONAL_AGENT_${i}_FIRST_NAME`]) || !additionalAgents.includes(property[`ADDITIONAL_AGENT_${i}_LAST_NAME`]))) {
                additionalAgents += additionalAgents ? ',' : '';
                if (property[`ADDITIONAL_AGENT_${i}_FIRST_NAME`]) {
                    additionalAgents += ' ' + property[`ADDITIONAL_AGENT_${i}_FIRST_NAME`];
                }
                if (property[`ADDITIONAL_AGENT_${i}_LAST_NAME`]) {
                    additionalAgents += ' ' + property[`ADDITIONAL_AGENT_${i}_LAST_NAME`];
                }
            }
        }
        return additionalAgents;
    }

    static buildRow(status, property) {
        let price = '$0';
        let grossFee = '$0';
        let additionalAgents = '';
        const percentage = parseFloat(property.LISTING_PERCENTAGE) + parseFloat(property.BUYING_PERCENTAGE);
        const downloads = property.USERS_ID ? property.USERS_ID.split(',').length : 0;

        switch (status) {
            case proposal:
            case active:
                price = property.LIST_PRICE;
                break;
            case negotiation:
            case underContract:
                price = property.NEGOTIATION_PRICE;
                grossFee = parseInt(property.NEGOTIATION_LISTING_GROSS_FEE) + parseInt(property.NEGOTIATION_BUYING_GROSS_FEE);
                additionalAgents = PipelineDetails.formatAdditionalAgents(property);
                break;
            case closed:
            case closedYTD:
            case closedHistorical:
                price = property.SOLD_PRICE;
                grossFee = parseInt(property.CLOSED_LISTING_GROSS_FEE) + parseInt(property.CLOSED_BUYING_GROSS_FEE);
                additionalAgents = PipelineDetails.formatAdditionalAgents(property);
                break;
            case listing:
                switch (property.STATUS) {
                    case active:
                        price = property.LIST_PRICE;
                        break;
                    case negotiation:
                    case underContract:
                        price = property.NEGOTIATION_PRICE;
                        grossFee = parseInt(property.NEGOTIATION_LISTING_GROSS_FEE) + parseInt(property.NEGOTIATION_BUYING_GROSS_FEE);
                        additionalAgents = PipelineDetails.formatAdditionalAgents(property);
                        break;
                }
                break;
        }

        return {
            ID: property.ARCIMEDES_ROW_ID,
            DATE_CREATED: property.DATE_CREATED ? stringISOtoUS(property.DATE_CREATED) : null,
            LISTED_DATE: property.LISTED_DATE ? stringISOtoUS(property.LISTED_DATE) : null,
            EXPIRATION_DATE: property.EXPIRATION_DATE ? stringISOtoUS(property.EXPIRATION_DATE) : null,
            STATUS: property.STATUS,
            CLOSE_OF_ESCROW: property.CLOSE_OF_ESCROW ? stringISOtoUS(property.CLOSE_OF_ESCROW) : null,
            NAME: property.NAME,
            ADDRESS: property.ADDRESS,
            CITY: property.CITY,
            STATE: property.STATE,
            PRICE: price ? parseInt(price) : 0,
            PERCENTAGE: percentage ? `${parseFloat(percentage).toFixed(2)}%` : '0.00%',
            SELLER_FEE_PERCENTAGE: property.SELLER_FEE_PERCENTAGE ? `${parseFloat(property.SELLER_FEE_PERCENTAGE).toFixed(2)}%` : '0.00%',
            GROSS_FEE: grossFee ? grossFee : 0,
            ADDITIONAL_AGENTS: additionalAgents,
            DOWNLOADS: downloads,
        }
    }

    static buildTableRows(status, data) {
        const tableData = [];
        data.map((property, index) => {
            tableData[index] = PipelineDetails.buildRow(status, property);
        });
        return tableData;
    }

    static buildTableTotal(data) {
        const price = calculateTotalColumn(data, 'PRICE');
        const grossFee = calculateTotalColumn(data, 'GROSS_FEE');
        const downloads = calculateTotalColumn(data, 'DOWNLOADS');
        return {
            ID: 'Total',
            DATE_CREATED: null,
            LISTED_DATE: null,
            STATUS: null,
            CLOSE_OF_ESCROW: null,
            NAME: calculateTotalColumn(data, 'NAME', true),
            ADDRESS: null,
            CITY: null,
            STATE: null,
            PRICE: price ? dollars(price) : '$0',
            PERCENTAGE: null,
            SELLER_FEE_PERCENTAGE: null,
            GROSS_FEE: grossFee ? dollars(grossFee) : '$0',
            ADDITIONAL_AGENTS: null,
            DOWNLOADS: downloads || 0,
        };
    }

    static buildTable(status, table, data) {
        const tableData = {...table};
        tableData.data = PipelineDetails.buildTableRows(status, data);
        const hasData = !!tableData.data.length;
        if (hasData) {
            tableData.total = PipelineDetails.buildTableTotal(tableData.data);
        }
        return tableData;
    }

    static renderTable(status, table, loading, isAgentPipeline) {
        const cols = PipelineDetails.getColumns(status, isAgentPipeline);
        const data = table.data;
        const total = table.total;
        const message = loading ? 'Loading data...' : 'No data available';
        return (
            <React.Fragment>
                <h4>{table.name}</h4>
                {
                    table.data.length ?
                        <table className='table'>
                            <thead>
                            <tr>
                                {
                                    cols.map((col, index) => {
                                        return (
                                            <th className={`th head border_top ${index === 0 ? 'border_left' : ''}`}
                                                key={col.key}>
                                                {col.label}
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {
                                Object.keys(data).map((rowKey, index) => {
                                    return (
                                        <tr key={index}>
                                            {
                                                cols.map((col, index) => {
                                                    if (col.key === 'ID') {
                                                        return;
                                                    }
                                                    const value = ['PRICE', 'GROSS_FEE'].includes(col.key) ? dollars(data[rowKey][col.key]) : data[rowKey][col.key];
                                                    return (
                                                        <td className={`td ${index === 0 ? 'border_left' : ''}`}
                                                            style={{textAlign: col.style ? 'center' : ''}}
                                                            key={`${index}_${data[rowKey].ID}`}>
                                                            {
                                                                col.key === 'NAME' ?
                                                                    <Link to={{pathname: `${arc.path.base}property/${data[rowKey].ID}`}} style={{cursor: 'pointer'}}>
                                                                        {value}
                                                                    </Link>
                                                                    : col.key === 'DOWNLOADS' ?
                                                                    <Link to={{pathname: `${arc.path.base}property-statistics/${data[rowKey].ID}`}} style={{cursor: 'pointer'}}>
                                                                        {value}
                                                                    </Link>
                                                                    :
                                                                    <div>{value}</div>
                                                            }
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                            <tfoot>
                            {
                                <tr>
                                    {
                                        data.length ? cols.map((col, index) => {
                                                if (index === 0) {
                                                    return <th className='th border_left' key='TOTAL'>Total</th>
                                                }
                                                return <th className='th' key={col.key}>{total[col.key]}</th>
                                            })
                                            :
                                            null
                                    }
                                </tr>
                            }
                            </tfoot>
                        </table>
                        :
                        <div className='no-data-found'>{message}</div>
                }

            </React.Fragment>
        )
    }

    render() {
        const {tables, agentName, loading} = this.state;
        const {withoutAgentName, isAgentPipeline} = this.props;

        return (
            <div className='agent-details-container'>
                {
                    withoutAgentName ?
                        null
                        :
                        <div className='agent-details'>
                            <h4 className='agent-name-label'>Name:</h4>
                            <h4 className='agent-name'>{agentName}</h4>
                        </div>
                }
                {
                    Object.keys(tables).map(key => {
                        return <div key={key}>{PipelineDetails.renderTable(key, tables[key], loading, isAgentPipeline)}</div>
                    })
                }
            </div>
        )
    }
}